import React from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import useGlobalModel from "./model/globalModel";
import { Login } from "./views/login/Login";
import Index from "./layout";
import 'moment/locale/zh-cn';
import zh_CN from 'antd/lib/locale/zh_CN';
import en_US from 'antd/lib/locale/en_US';
import { HashRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import { setToken } from './utils/constants';
import { urlParse } from "@/utils/utils";
import TokenLogin from './views/login/TokenLogin'

function App() {
    const { user, language } = useGlobalModel()

    function loginCheck() {
        // const url = 'https://localhost:3000?appId=fe166577ae924ac09a9638daa2d6e0b7&appCode=yunchuang&token=eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJmMjdkOTgyMjgxODQ0OTBmYjI0ZjEyYjNlMmU0ZjUxMiIsInN1YiI6IuaIkeaYr-S6keixquWRmOW3pSIsImlhdCI6MTYxNTY1NTU5NywidXNlclN0YXR1cyI6MCwidXNlckFjY291bnQiOiJhZG1pbiIsInVzZXJUeXBlIjoxLCJ1c2VyTmFtZSI6IuaIkeaYr-S6keixquWRmOW3pSIsInVzZXJJZCI6ImYyN2Q5ODIyODE4NDQ5MGZiMjRmMTJiM2UyZTRmNTEyIiwic3RhZmZJZCI6IjUiLCJleHAiOjE2MTU2OTE1OTd9.UZKNk1_6e5bcruYRh9KUrvQ_d-NIxXCcJBDJVnDYs9Y'
        const url = window.location.href
        let urlObj = urlParse(url);

        if (urlObj.token) {
            setToken(urlObj.token)
            return <TokenLogin token={urlObj.token} />
        }
        return <Login />
    }
    return (
        <ConfigProvider locale={language === "zh-CN" ? zh_CN : en_US}>
            <HashRouter>
                <Switch>
                    <Route path="/login" component={() => loginCheck()} />
                    <Route path="/" render={
                        () => user.token ? <Index /> : <Redirect to="/login" />}
                    />
                </Switch>
            </HashRouter>
        </ConfigProvider>
    );
}

export default App;
